import { createFileRoute, redirect } from "@tanstack/react-router";

import { sdk } from "@/api/sdk";
import { SettingsList } from "@/components/settings/settings-list";
import { PaymentRulesSettings } from "@/features/finance/modules/payment-policy/payment-rules-settings";
import { PaymentSetup } from "@/features/finance/modules/payment-setup/payment-setup";
import { TaxProfileForm } from "@/features/finance/modules/tax-profile/tax-profile-form";
import { YourRates } from "@/features/finance/modules/your-rates/your-rates";
import { hasPermissionInList } from "@/features/navigation/filter-nav-entries";
import { m } from "@/paraglide/messages.js";
import { PermissionAction, PermissionSubject } from "@complete-athlete/enums";

export const Route = createFileRoute("/(private)/finances/settings/")({
  beforeLoad: async () => {
    const { data } = await sdk.users.me.$get.send();
    if (!hasPermissionInList(data?.permissions ?? null, PermissionAction.MANAGE, PermissionSubject.FINANCE)) {
      throw redirect({ to: "/" });
    }
  },
  loader: () => ({ crumb: m.finance_settings_title() }),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="grid gap-8 xl:grid-cols-[minmax(0,1fr)_380px]">
      <SettingsList className="content-start">
        <PaymentSetup />
        <TaxProfileForm />
        <PaymentRulesSettings />
      </SettingsList>
      <SettingsList className="content-start">
        <YourRates />
      </SettingsList>
    </div>
  );
}
